import { render, staticRenderFns } from "./View.vue?vue&type=template&id=d3a15d8c&scoped=true&class=b-card&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"
import style0 from "./View.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./View.vue?vue&type=style&index=1&id=d3a15d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a15d8c",
  null
  
)

export default component.exports